import axios from 'axios';
import { normalize } from 'normalizr';

import * as schema from '../schema';
import { apiRoute } from '../../utils/api';
import {
	FETCH_DATA_REQUEST,
	FETCH_DATA_SUCCESS,
	FETCH_DATA_FAILURE,
} from '../types';

export const fetchData = () => {
	return dispatch => {
		dispatch({
			type: FETCH_DATA_REQUEST,
		});

		return axios.get(`${apiRoute}/dale/v1/data`) 
			.then(res => {
				let { 
					files, 
					notifications, 
					messages,
				} = res.data;

				if (notifications === null) {
					notifications = {};
				}

				dispatch({
					type: FETCH_DATA_SUCCESS,
					payload: {
						files: normalize(files, [ schema.file ]),
						notifications: normalize(notifications, [ schema.notification ]),
						messages,
					}
				})
			})
			.catch(error => { 
				dispatch({
					type: FETCH_DATA_FAILURE,
					payload: 'Something went Wrong please refresh to try again!',
				})
			});
	}
}


// WEBPACK FOOTER //
// ./src/store/data/actions.js